import { injectIntl } from 'react-intl';

import RelativeFilter from './RelativeFilter';

export default injectIntl(RelativeFilter);
